import * as React from 'react';

export const Message: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex flex-col">
      <div className="grow flex flex-col text-center justify-center py-12">{children}</div>
    </div>
  );
};
Message.displayName = 'Message';
